
export const formatCurrency = ({
    price,
    language = "en-GB",
    currency = "GBP",
}) => {
    return new Intl.NumberFormat(language, {
        style: "currency",
        currency,
    }).format(price);
};

export const orderSummaryRestaurant = (slackData, orderData) => {
    try {
        const { sales = [] } = orderData;
        console.log("orderSummaryRestaurant", orderData);
    
        const salesLineItems = getSalesItemsForRestaurants(sales);

        const text = `${salesLineItems}`;

        return {
            ...slackData,
            orderSummary: {
                type: "section",
                text: {
                    type: "mrkdwn",
                    text,
                },
            },
        };
    } catch (e) {
        console.log("orderSummaryRestaurant", e);
        return slackData;
    }
};

export const getSalesItemsForRestaurants = (sales) => {
    return sales.reduce((accumSaleText, currentSale, index) => {
        const text = getSalesLineItemForRestaurants(currentSale);
        accumSaleText += `*Item ${index + 1}.*  \n ${text}  \n`;
        return accumSaleText;
    }, "  \n");
}

export const getSalesLineItemForRestaurants = (sale) => {
    const { name, quantity, price } = sale;
    const totalAmount = Number(price / 100) * Number(quantity);

    return `Main: ${name} \n Quantity: ${quantity} x ${formatCurrency({ price: Number(price / 100) })}  \n Total amount: ${formatCurrency({ price: totalAmount })}  \n`;
}

export const dataBuilderForRestaurants = (orderPayload) => {
    return [orderSummaryRestaurant].reduce(
        (data, func) => func(data, orderPayload),
        {}
    );
};

export const convertToMarkDown = (order) => {
    const blocks = dataBuilderForRestaurants(order);
    const parsedBlocks = Object.values(blocks);

    return parsedBlocks.map(({ text }) => text && text.text).join(" ");
};